import TakingOrderTable from "./component/TakingOrderTable";

function TakingOrderPreparing() {

  return (
    <>
      <TakingOrderTable status={2} nextStatus={3} hasAction/>
    </>
  );
}

export default TakingOrderPreparing;
